import { render, staticRenderFns } from "./QuanLyNhanSu.vue?vue&type=template&id=7d5ae932"
import script from "./QuanLyNhanSu.vue?vue&type=script&lang=js"
export * from "./QuanLyNhanSu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports